import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * JSON-LD LocalBusiness schema for Ridgehawk Logistics.
 * Renders inline as a <script type="application/ld+json"> tag via Helmet.
 */
const SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://ridgehawk.ca/#organization",
      name: "Ridgehawk Logistics Inc.",
      url: "https://ridgehawk.ca",
      logo: "https://ridgehawk.ca/logo.jpeg",
      sameAs: [],
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://ridgehawk.ca/#business",
      name: "Ridgehawk Logistics",
      description:
        "Premium courier and logistics services in Milton, Ontario. Same-day courier, certified medical transport, last-mile delivery, B2B freight, and dedicated route contracts across the Greater Toronto Area.",
      url: "https://ridgehawk.ca",
      telephone: "",
      email: "info@ridgehawk.ca",
      image: "https://ridgehawk.ca/logo.jpeg",
      logo: "https://ridgehawk.ca/logo.jpeg",
      priceRange: "$$",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Milton",
        addressRegion: "ON",
        addressCountry: "CA",
      },
      areaServed: [
        "Milton, ON",
        "Oakville, ON",
        "Burlington, ON",
        "Georgetown, ON",
        "Acton, ON",
        "Halton Hills, ON",
        "Mississauga, ON",
        "Brampton, ON",
        "Hamilton, ON",
        "Toronto, ON",
        "Vaughan, ON",
        "Markham, ON",
        "Richmond Hill, ON",
        "Kitchener-Waterloo, ON",
        "Cambridge, ON",
        "Guelph, ON",
        "Niagara Region, ON",
      ],
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "07:00",
          closes: "19:00",
        },
      ],
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "customer service",
          email: "info@ridgehawk.ca",
          areaServed: "CA-ON",
          availableLanguage: ["English"],
        },
      ],
      knowsAbout: [
        "Same-day courier",
        "Medical transport",
        "Pharmaceutical transport",
        "Last-mile parcel delivery",
        "B2B freight",
        "Dedicated route contracts",
        "WHMIS",
        "Transportation of Dangerous Goods",
        "Bloodborne Pathogens",
      ],
    },
  ],
};

export default function LocalBusinessSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(SCHEMA)}</script>
    </Helmet>
  );
}
